export default "__VITE_ASSET__Dcaxh23T__"